import { useTranslation } from "react-i18next";
import InputAdornment from "@mui/material/InputAdornment";

import TextField from "features/components/TextField";
import SearchIcon from "features/ui/Icons/SearchIcon";

import type { ThreadListVariant } from "./types";

interface ThreadListSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  variant?: ThreadListVariant;
  inputRef?: React.RefObject<HTMLInputElement | null>;
}

const ThreadListSearch = ({
  searchQuery,
  onSearchChange,
  variant = "menu",
  inputRef,
}: ThreadListSearchProps) => {
  const { t } = useTranslation("duck");
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Stop propagation in menu context to prevent Menu from handling keyboard events
    if (variant === "menu") {
      event.stopPropagation();
      event.preventDefault();
    }

    onSearchChange(event.target.value);
  };

  const searchField = (
    <TextField
      fullWidth
      autoFocus={variant === "menu"}
      placeholder={t("search_for_chats")}
      aria-label={t("search_chats")}
      data-testid="thread-search-input"
      onChange={handleInputChange}
      value={searchQuery}
      inputRef={inputRef}
      hiddenLabel={true}
      variant="outlined"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon aria-hidden="true" />
            </InputAdornment>
          ),
        },
      }}
    />
  );

  return <div className="p-2">{searchField}</div>;
};

export default ThreadListSearch;
